import React from 'react'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import { useNavigate } from 'react-router-dom'

function WatiTemplateList() {

  const templates = [
    {label:'template_send_image',value:'Template Send Image',status:true},
    {label:'template_send_video',value:'Template Send Video',status:true},
    {label:'template_send_document',value:'Template Send Document',status:true},
    {label:'reply_message_main',value:'Replay Message Main',status:true},
    {label:'reply_message1',value:'Replay Message1',status:false},
    {label:'finalning',value:'Final Message',status:false},
  ]  
 

  // https://ap.wati-assets.io/wwwroot/data/464571/data/videos/WhatsApp_Video_2025_08_26_at_10.09.34_AM_2_1_-82e1322b-04a9-4856-9c08-495c8ca0845d.mp4?Expires=1760156018&KeyName=mt-prod-wati-media-files&Signature=0AP8YSiIuNOyWpaaRvUrQcXrzUc=
  const navigate = useNavigate()

  return (
     <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
        <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div>
            <div className='pt-5'>
                <div className="flex justify-between align-center items-center border-b pb-2 ">
                <span className="font-[800] text-[14px]">Wati's Template</span>
                </div>
            </div>
            
            <div className='grid grid-cols-2 md:grid-cols-5'>
                {templates?.map((t)=>(  
                <div onClick={()=>navigate(`${t?.label}`)} className='border relative hover:bg-[#2a297e] cursor-pointer hover:text-white p-2 m-2 text-[13px] font-[600]' key={t?.label}>
                    {t?.status && <h6 className='bg-[#de9f19] p-[2px] absolute right-0 top-0 text-[8px] font-[700]'>Active</h6>}
                    <h6>{t?.value}</h6>
                </div>))}
            </div>


        </div>
        </div>
        </div>  

     </div>   
  )
}

export default WatiTemplateList